/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, May 21st 2022, 1:44:36 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from "config";

export const AuthFooter = () => (
  <p className="auth-copyright">
    Copyright {new Date().getFullYear()} | All Rights Reserved.
    <br />
    <a href={TERMS_OF_SERVICE_URL} target="_blank" rel="noreferrer">
      Terms of Service
    </a>{" "}
    and{" "}
    <a href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">
      Privacy Policy
    </a>
  </p>
);
